<template>
  <div>
    <template v-if="widgets.length > 0">
      <div class="cfg_content flow">
        <div class="head flex flex-row items-center">
          <span class="basis-1/2"/>
          <a class="basis-1/4">可见</a>
          <a class="basis-1/4">可编辑</a>
        </div>
      </div>
      <div class="flex flex-row">
        <div class="basis-1/2 overflow-hidden">
          <ul class="select-list">
            <li style="color: #0db3a6;">全选</li>
            <li v-for="_widget in widgets" :key="_widget.key">
              <div class="name">{{ _widget.name }}</div>
            </li>
          </ul>
        </div>
        <div class="basis-1/4">
          <ul class="select-list">
            <li>
              <el-checkbox
                  v-model="viewCheckAllValue" :indeterminate="viewIndeterminate" @change="handleCheckAllViewChange"
              />
            </li>
            <el-checkbox-group v-model="checkedViewWidgets">
              <li v-for="_widget in widgets" :key="_widget.key">
                <el-checkbox :label="_widget.key" @change="handleCheckedViewWidgetsClick($event, _widget.key)">
                  <br/>
                </el-checkbox>
              </li>
            </el-checkbox-group>
          </ul>
        </div>
        <div class="basis-1/4">
          <ul class="select-list">
            <li>
              <el-checkbox
                  v-model="editCheckAllValue" :indeterminate="editIndeterminate" @change="handleCheckAllEditChange"
              />
            </li>

            <el-checkbox-group v-model="checkedEditWidgets">
              <li v-for="_widget in widgets" :key="_widget.key">
                <el-checkbox :label="_widget.key" @change="handleCheckedEditWidgetsClick($event, _widget.key)"><br/>
                </el-checkbox>
              </li>
            </el-checkbox-group>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="h-30 w-full bg-slate-100 flex flex-col items-center text-slate-400">
        <i class="bi my-2 bi-columns-gap text-2xl"></i>
        <div class="text-xs">请先为表单添加字段</div>
        <div><el-button type="text" size="medium"><Link :href="zroute('app.form.edit', [app_id, form_id])">前往添加</Link></el-button></div>
      </div>
    </template>
  </div>
</template>

<script>
import {debounce} from 'lodash/function'
import {Link} from '@inertiajs/inertia-vue'
import zroute from '../ziggy'

export default {
  components: {
    Link,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    widgets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      form_id: zroute().params.form_id,
      pin: false,
      editCheckAllValue: false,
      viewCheckAllValue: false,
      viewIndeterminate: false,
      editIndeterminate: false,
      viewClickIndex: -1,
      editClickIndex: -1,
      checkedViewWidgets: [],
      checkedEditWidgets: [],
      widgetIds: this.widgets.map(item => item.key),
    }
  },
  computed: {
    result() {
      return this.widgets.map(item => {
        return {
          key: item.key,
          view: this.checkedViewWidgets.indexOf(item.key) > -1,
          edit: this.checkedEditWidgets.indexOf(item.key) > -1,
        }
      }).filter(item => item.view || item.edit)
    },
  },
  watch: {
    value(val) {
      console.log('WidgetsCheckGroup value changed', val)
      this.checkedViewWidgets = val.filter(v => v.view).map(v => v.key)
      this.checkedEditWidgets = val.filter(v => v.edit).map(v => v.key)
    },
    checkedViewWidgets: {
      handler(val) {
        // console.log('checkedViewWidgets changed', val)
        this.viewCheckAllValue = val.length === this.widgets.length
        this.viewIndeterminate = val.length > 0 && val.length < this.widgets.length
        //取消选中可见同时取消选中可编辑
        //要取消可编辑的widget
        let filter_ids = this.widgetIds.filter(id => val.indexOf(id) === -1).filter(id => this.checkedEditWidgets.indexOf(id) > -1)
        if (filter_ids.length > 0) {
          this.checkedEditWidgets = this.checkedEditWidgets.filter(id => filter_ids.indexOf(id) === -1)
        }
        // this.$emit('input', this.result)
      },
      deep: true,
      immediate: true,
    },
    checkedEditWidgets: {
      handler(val) {
        this.editCheckAllValue = val.length === this.widgets.length
        this.editIndeterminate = val.length > 0 && val.length < this.widgets.length
        //选中可编辑同时选中可见
        let checkIds = val.filter(item => this.checkedViewWidgets.indexOf(item) === -1)
        if (checkIds.length > 0) {
          this.checkedViewWidgets = this.checkedViewWidgets.concat(checkIds)
        }


      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.checkedViewWidgets = this.value.filter(v => v.view).map(v => v.key)
    this.checkedEditWidgets = this.value.filter(v => v.edit).map(v => v.key)
    window.addEventListener('keydown', code => this.handleKeyDown(code)) // 监听键盘按下事件
    window.addEventListener('keyup', code => this.handleKeyUp(code)) // 监听键盘松开事件
  },
  beforeDestroy() {

    // 销毁监听键盘事件
    window.removeEventListener('keydown', code => this.handleKeyDown(code))
    window.removeEventListener('keyup', code => this.handleKeyUp(code))
  },
  created() {
    // console.log('WidgetsCheckGroup created', this.value)
  },
  methods: {
    handleCheckAllEditChange(val) {
      // console.log('handleCheckAllEditChange', val)
      // this.checkedWidgets = []
      this.checkedEditWidgets = val ? this.widgetIds : []
      // this.isEditIndeterminate = false
      this.$emit('input', this.result)
    },
    handleCheckAllViewChange(val) {
      // this.checkedWidgets = []
      // this.isViewIndeterminate = false
      this.checkedViewWidgets = val ? this.widgetIds : []
      this.$emit('input', this.result)

    },
    handleCheckedViewWidgetsClick(val, key) {
      // console.log('handleCheckedViewWidgetsClick', event, this.widgetIds.indexOf(event))
      if (this.pin && this.viewClickIndex > -1) {
        //last index is checked
        let checked = this.checkedViewWidgets.indexOf(this.widgetIds[this.viewClickIndex]) > -1
        let index = this.widgetIds.indexOf(key)
        //get array from index to end
        let arr = this.widgetIds.slice(Math.min(index, this.viewClickIndex), Math.max(index, this.viewClickIndex) + 1)
        if (checked) {
          this.checkedViewWidgets.push(...(arr.filter(item => this.checkedViewWidgets.indexOf(item) === -1)))
        } else {
          this.checkedViewWidgets = this.checkedViewWidgets.filter(item => arr.indexOf(item) === -1)
        }

      } else {
        this.viewClickIndex = this.widgetIds.indexOf(key)
      }
      this.$emit('input', this.result)
    },
    handleCheckedEditWidgetsClick(val, key) {
      if (this.pin && this.editClickIndex > -1) {
        //last index is checked
        let checked = this.checkedEditWidgets.indexOf(this.widgetIds[this.editClickIndex]) > -1
        let index = this.widgetIds.indexOf(key)
        //get array from index to end
        let arr = this.widgetIds.slice(Math.min(index, this.editClickIndex), Math.max(index, this.editClickIndex) + 1)
        if (checked) {
          this.checkedEditWidgets.push(...(arr.filter(item => this.checkedEditWidgets.indexOf(item) === -1)))
        } else {
          this.checkedEditWidgets = this.checkedEditWidgets.filter(item => arr.indexOf(item) === -1)
        }

      } else {
        this.editClickIndex = this.widgetIds.indexOf(key)
      }
      this.$emit('input', this.result)
    },

    // 监听按下键盘事件
    handleKeyDown: debounce(function (code) {

      if (code.keyCode === 16 && code.shiftKey) {
        // 判断是否按住shift键，是就把pin赋值为true
        this.pin = true
      }
    }, 200, true),
    handleKeyUp: debounce(function (code) {

      if (code.keyCode === 16) {
        // 判断是否松开shift键，是就把pin赋值为false
        this.pin = false
      }
    }, 200, true),
  },
}
</script>

<style lang="scss" scoped>
.cfg_content {
  flex: none;
  position: relative;
  font-size: 13px;

  .head {
    border-top: solid 1px #ddd;
    padding: 0 5px;
    border-bottom: solid 1px #ddd;
    height: 30px;
    background: #FAFAFA;
    line-height: 30px;

    .opt {
      position: relative;
      float: right;
      right: 16px;
      margin-left: 50px;
    }

    a {
      color: rgba(0, 0, 0, 0.75);
      outline: 0;
      text-decoration: none;
    }
  }
}

.select-list {
  font-size: 13px;

  .select-all {
    span {
      color: #0db3a6;
    }
  }

  li:not(:last-child) {
    height: 40px;
    border-bottom: 1px solid #ddd;
  }
}
</style>
